export const ProjectNameMinimumLength = 2;
export const ProjectNameMinimumLengthError = `Should have ${ProjectNameMinimumLength} characters or more and contain only valid characters`;

export const IterationNameMinimumLength = 2;
export const iterationNameMinimumLengthError = `Should have ${IterationNameMinimumLength} characters or more and contain only valid characters`;
